module.exports = __webpack_public_path__ + "img/p1.1340b13b.png";